import React, { useState } from "react";
import classNames from "classnames";
import { useMoodsContext } from "store/contexts/moodsContext";
import Button from "components/CustomButton";
import { useTimelineContext } from "store/contexts/timelineContext";
import checkInCreatedImage from "assets/img/check_in_created.png";
import checkedbox from "assets/img/icons/check_in_checkbox_checked.png";
import uncheckedbox from "assets/img/icons/check_in_checkbox_unchecked.png";
import { Modal } from "react-responsive-modal";
import Avatar from "components/Avatar";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import { useToasts } from "react-toast-notifications";
import { useParams } from "react-router-dom";

var styles = {
  checkinContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    paddingTop: "20px",
  },
  moodDailog: {
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px 20px",
  },
  activeMoodName: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "10px",
  },
  checkBox: {
    cursor: "pointer",
    padding: "5px 0px",
  },
  cancelButton: {
    width: "102px",
    background: "none",
    color: "black",
  },
  titleDivider: {
    backgroundColor: "#434343",
    paddingBottom: "2px",
    marginBottom: "10px",
  },
  dailogHeaderReaction: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "16px 24px",
  },
  heading: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    margin: "0px 8px",
  },
  initatedResponse: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
  },
  actionButton: {
    padding: "8px",
    display: "flex",
    gap: "10px",
  },
  checkBoxContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  private: {
    fontSize: "13px",
    letterSpacing: "0.3px",
  },
};

export default ({ post }) => {
  const classes = styles;
  const { moods } = useMoodsContext();
  const safeMoods = moods || [];
  const [dialogState, setDialogState] = useState(false);
  const [activeMood, setActiveMood] = useState(safeMoods[0] || null);
  const [initateResponse, setInitateResponse] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const { createPost, deletePost } = useTimelineContext();
  const [alreadyCreated, setAlreadyCreated] = useState(false);
  const { addToast } = useToasts();
  const { postId } = useParams();

  const submitCheckInResponse = async (event) => {
    setLoading(true);
    try {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      var response = await TeamService.postCheckInResponse(
        post?.team_id,
        post.data.checkin_id,
        activeMood.id,
        checkBox
      );

      if (!postId) {
        await Promise.all([createPost(response?.data?.data), deletePost(post)]);
      }

      setInitateResponse(true);
    } catch (e) {
      console.log(e.response);

      if (e.response.data.status === 409) {
        closeDailog();
        addToast(e.response.data.message, { appearance: "error" });
        setAlreadyCreated(true);
      }
    }
    setLoading(false);
  };

  const closeDailog = () => {
    setDialogState(false);
  };

  return (
    <>
      <div style={classes.checkinContainer}>
        <Button
          buttonClass={"grad_btn join-btn"}
          disabled={(initateResponse || alreadyCreated) && true}
          onClick={() => setDialogState(true)}
        >
          Check-in
        </Button>
      </div>
      <Modal
        classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
        open={dialogState}
        showCloseIcon={false}
        onClose={() => closeDailog(false)}
      >
        <div style={classes.dailogHeaderReaction}>
          <Avatar src={post?.user?.avatar} alt={post?.user?.avatar} />
          <div style={classes.heading}>
            <span style={{ fontSize: "12px", textTransform: "capitalize" }}>
              {post?.user?.full_name}
            </span>
            <span style={{ fontSize: "12px", textTransform: "capitalize" }}>
              Initiate a check-in Request
            </span>
          </div>
        </div>
        <hr style={classes.titleDivider} />
        <div style={{ padding: "8px 24px" }}>
          {!initateResponse && (
            <div style={classes.moodDailog}>
              <div style={{ display: "flex" }}>
                {moods?.map((mood, index) => (
                  <Avatar
                    key={mood.name}
                    className={classNames("checkinMoodAvatar", {
                      checkinActiveMood: activeMood === mood && true,
                    })}
                    onClick={() => setActiveMood(mood)}
                    src={mood.media}
                    alt={mood.name}
                  />
                ))}
              </div>
              <span style={classes.activeMoodName}>{activeMood?.name}</span>
              <div style={classes.checkBoxContent}>
                <div style={classes.checkBox}>
                  {checkBox && (
                    <Avatar
                      rootStyle={{ borderRadius: "0%" }}
                      onClick={() => setCheckBox(false)}
                      alt={"checkedbox"}
                      src={checkedbox}
                    />
                  )}
                  {!checkBox && (
                    <Avatar
                      rootStyle={{ borderRadius: "0%" }}
                      onClick={() => setCheckBox(true)}
                      alt={"uncheckedbox"}
                      src={uncheckedbox}
                    />
                  )}
                </div>
                <span style={classes.private}>Keep Private</span>
              </div>
            </div>
          )}
          {initateResponse && (
            <div style={classes.initatedResponse}>
              <img alt={"checkinCreated"} src={checkInCreatedImage} />
              <span
                style={{
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                Your Check-in response has been sent to the initiator
              </span>
            </div>
          )}
        </div>
        <div style={classes.actionButton}>
          <Button
            buttonClass={"grad_btn cancelButton"}
            onClick={() => closeDailog()}
            buttonStyle={classes.cancelButton}
          >
            Cancel
          </Button>
          <Button
            buttonClass={"grad_btn join-btn"}
            disabled={(loading || initateResponse) && true}
            onClick={submitCheckInResponse}
            name={
              !loading ? (
                "Submit your Check-in"
              ) : (
                <Loader width={30} height={30} />
              )
            }
          />
        </div>
      </Modal>
    </>
  );
};
